import React from "react";
import { connect } from "react-redux";
import { numberWithCommas } from '$Deposits/lib/LibCommonData'
import { SetDepositMoneyStatus } from '$Deposits/store/actions/DepositAction'
import { GetParamsData } from '$Deposits/lib/LibCommonData'

class MoneyInput extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };

    }

    componentDidUpdate(prevProps, prevState) {

    }
    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {

        const {
            MethodsDetails,
            MethodsActive,
            SetDepositMoneyStatus,
            DepositMoneyStatus,
            MethodCodeActive,
            MoneyInput,
            PHCMoneyInput,
            SuggestedAmounts,
        } = this.props;
        const { code } = MethodsActive || {}
        const { maxBal, minBal, charges } = MethodsDetails && MethodsDetails.setting || {}
        const { money, moneyErrMsg } = DepositMoneyStatus || {}
        const chargesMoney = money - (money * Math.abs(charges))
        const { LivechatClick } = GetParamsData()
        return (
            <>
                {
                    MethodCodeActive != 'CHANNEL' && code != 'PHC' &&
                    <>
                        <MoneyInput
                            title={'Số Tiền Gửi (1=1,000)'}
                            stateVal={moneyErrMsg}
                            value={money}
                            placeholder={`Giới hạn gửi tối thiểu ${numberWithCommas(minBal)}đ tối đa ${numberWithCommas(maxBal)}đ`}
                            onChange={(value) => { SetDepositMoneyStatus(value, MethodsDetails) }}
                            MethodCodeActive={MethodCodeActive}
                        />
                        {/* <div className="CTC-tips">Lưu ý: Nếu số tiền gửi là 500,000, vui lòng chỉ điền 500</div> */}
                    </>
                }
                {
                    code == 'PHC' &&
                    <PHCMoneyInput
                        title={'Chọn Mệnh Giá Thẻ Cào'}
                        SuggestedAmounts={SuggestedAmounts}
                        chargesMoney={chargesMoney}
                        value={money}
                        stateVal={moneyErrMsg}
                        onChange={(value) => { SetDepositMoneyStatus(value, MethodsDetails) }}
                        LivechatClick={LivechatClick}
                    />
                }
            </>
        );
    }
}

const mapStateToProps = state => ({
    MethodsActive: state.MethodsActive,
    MethodsDetails: state.MethodsDetails,
    DepositMoneyStatus: state.DepositMoneyStatus,
    MethodCodeActive: state.MethodCodeActive,
    SuggestedAmounts: state.SuggestedAmounts,
});
const mapDispatchToProps = {
    SetDepositMoneyStatus: (money, methodsDetails) => SetDepositMoneyStatus(money, methodsDetails),
};
export default connect(mapStateToProps, mapDispatchToProps)(MoneyInput);


